module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/changepassword/changepassword.component.scss
// module id = ./src/app/component/changepassword/changepassword.component.scss
// module chunks = main